import Icon, { IconProps } from '@/components/elements/Icon';

export type AngleUpProps = IconProps;

/**
 * @component AngleUp
 */
function AngleUp({ ...rest }: AngleUpProps) {
  return (
    <Icon viewBox="0 0 24 24" useStroke {...rest}>
      <path
        stroke="none"
        d="M16.9999 13.4108L12.7099 9.1708C12.617 9.07707 12.5064 9.00268 12.3845 8.95191C12.2627 8.90114 12.132 8.875 11.9999 8.875C11.8679 8.875 11.7372 8.90114 11.6154 8.95191C11.4935 9.00268 11.3829 9.07707 11.2899 9.1708L7.04995 13.4108C6.95622 13.5038 6.88183 13.6144 6.83106 13.7362C6.78029 13.8581 6.75415 13.9888 6.75415 14.1208C6.75415 14.2528 6.78029 14.3835 6.83106 14.5054C6.88183 14.6272 6.95622 14.7378 7.04995 14.8308C7.23731 15.017 7.49076 15.1216 7.75495 15.1216C8.01913 15.1216 8.27259 15.017 8.45995 14.8308L11.9999 11.2908L15.5399 14.8308C15.7262 15.0155 15.9776 15.1197 16.2399 15.1208C16.3716 15.1216 16.502 15.0963 16.6239 15.0466C16.7457 14.9968 16.8565 14.9235 16.9499 14.8308C17.047 14.7412 17.1254 14.6332 17.1805 14.5131C17.2356 14.3931 17.2664 14.2633 17.271 14.1312C17.2757 13.9992 17.2541 13.8675 17.2076 13.7439C17.161 13.6202 17.0905 13.507 16.9999 13.4108Z"
      />
    </Icon>
  );
}

export default AngleUp;
